import React from 'react';
import { CreditCardIcon, LockIcon } from 'lucide-react';
import { Section, CTAButton } from './shared';
export function FinalCTA() {
  return <div className="w-full bg-navy py-16 sm:py-20" data-id="element-85" data-mp="3ue8cbsdediwn">
      <Section data-id="element-86" data-mp="c70xva6rjfok">
        <div className="text-center" data-id="element-87" data-mp="c7k59wyseloc">
          <div className="flex justify-center" data-id="element-88" data-mp="c4ftadf2yln4">
            <CTAButton size="lg" data-id="element-89" data-mp="844al66a2vea">QUIERO MI MEGAPACK AHORA</CTAButton>
          </div>
          <p className="mt-6 font-display text-lg font-bold text-gold-soft" data-id="element-90" data-mp="m4f0o6zrk5ye">
            GARANTÍA 45 DÍAS — Sin preguntas · Devolución 100%
          </p>

          <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-blue-100/85" data-id="element-91" data-mp="h3rdxxikib9z">
            <span className="inline-flex items-center gap-2 rounded-lg bg-white/10 px-4 py-2 font-semibold text-white" data-id="element-92" data-mp="qvoqb7lbb9aa">
              Mercado Pago
            </span>
            <span className="inline-flex items-center gap-2" data-id="element-93" data-mp="14vzfm66z4ftc">
              <CreditCardIcon className="h-4 w-4 text-gold-soft" aria-hidden="true" data-id="element-94" data-mp="zx4p0i2rlmyo" />
              Tarjeta de crédito / débito
            </span>
            <span className="inline-flex items-center gap-2" data-id="element-95" data-mp="2c6hl0kt8o7if">
              <LockIcon className="h-4 w-4 text-gold-soft" aria-hidden="true" data-id="element-96" data-mp="2h4ssiow2a5xh" />
              Pago 100% seguro
            </span>
          </div>
        </div>
      </Section>
    </div>;
}